import { render, staticRenderFns } from "./ReadOnlyAttributeCard.vue?vue&type=template&id=b801a370&"
import script from "./ReadOnlyAttributeCard.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyAttributeCard.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyAttributeCard.vue?vue&type=style&index=0&id=b801a370&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports